import './App.css';
import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from './Pages/Member/Login';
import ResetPassword1 from './Pages/Member/ResetPassword1';
import ResetPassword2 from './Pages/Member/ResetPassword2';
import Logout from './Pages/Member/Logout';
import ChangedLanguage from './Pages/ChangedLanguage';
import Session from './Components/Session';
import Dashboard from './Pages/Dashboard';
import Crm from './Pages/Crm';
import CrmList from './Pages/CrmList';
import FinancePricingMarketPlace from './Pages/Finance/Pricing/MarketPlace';
import IncomingPayments from './Pages/IncomingPayments';
import PosProviderDefaultSystemPosProvider from './Pages/Finance/PosProvider/DefaultSystemPosProvider';
import MoneyTransferList from './Pages/MoneyTransferList';
import MoneyTransfer from './Pages/MoneyTransfer';

import MarketPlaceManagementOrders from './Pages/MarketPlaceManagement/Orders';
import MarketPlaceManagementListings from './Pages/MarketPlaceManagement/Listings';
import SystemDefinitionsCategoryManagement from './Pages/SystemDefinitions/CategoryManagement';
import SystemDefinitionsSliderManagement from './Pages/SystemDefinitions/SliderManagement';


const publicRoutes = [
  // Authentication Page
  { path: "/changed-language", component: ChangedLanguage },
  { path: "/login", component: Login },
  { path: "/reset-password-1", component: ResetPassword1 },
  { path: "/reset-password-2", component: ResetPassword2 },
  { path: "/logout", component: Logout },
];

const authProtectedRoutes = [

  { path: "/", component: Session },
  { path: "/dashboard", component: Dashboard },
  { path: "/crm", component: CrmList },
  { path: "/crm/:crmId?/:tabId?", component: Crm },
  { path: "/finance/pricing/market-place", component: FinancePricingMarketPlace },
  { path: "/finance/incoming-payments", component: IncomingPayments },
  { path: "/finance/incoming-payments", component: IncomingPayments },
  { path: "/finance/pos-provider/default-system-pos-provider", component: PosProviderDefaultSystemPosProvider },
  { path: "/finance/money-transfer", component: MoneyTransferList },
  { path: "/finance/money-transfer/:moneyTransferId?", component: MoneyTransfer },
  { path: "/finance/money-transfer/:moneyTransferId?/baseInformation", component: MoneyTransfer },
  { path: "/market-place-management/orders", component: MarketPlaceManagementOrders },
  { path: "/market-place-management/listings", component: MarketPlaceManagementListings },
  { path: "/system-definitions/category-management", component: SystemDefinitionsCategoryManagement },
  { path: "/system-definitions/slider-management", component: SystemDefinitionsSliderManagement },
];


function App() {
  return (
    <div className="App">
      <Routes>
        <React.Fragment>
          {publicRoutes.map((route, idx) => (
            route.template !== "" ?
              <Route
                path={route.path}
                element={<><route.component template={route.template} /></>}
                key={idx}
                exact={true}
              /> : <Route
                path={route.path}
                element={<><route.component /></>}
                key={idx}
                exact={true}
              />
          ))}
          {authProtectedRoutes.map((route, idx) => (
            route.template !== "" ?
              <Route
                path={route.path}
                element={<><Session><route.component template={route.template} /></Session></>}
                key={idx}
                exact={true}
              /> : <Route
                path={route.path}
                element={<><Session><route.component /></Session></>}
                key={idx}
                exact={true}
              />
          ))}
        </React.Fragment>
      </Routes>
    </div>
  );
}

export default App;
